import { ColDef } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import Typography from "@mui/material/Typography";
import { ProcessedHistoryData } from "@/store/budgets/selectors/details-drawer/budgetDetailsHistoryProcessedDataSelector";
import { budgetDetailsHistoryTableDateComparatorFn } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/utils/helpers/budgetDetailsHistoryTableDateComparatorFn";
import { money } from "@/utils/numeral/money";
import {
  budgetDetailsHistoryUsedComparator,
  getBudgetDetailsHistoryVarianceComparator,
} from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/history-section/utils/helpers/comparators";
import { BudgetDetailsHistoryUsedCell } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/history-section/cells/BudgetDetailsHistoryUsedCell";
import { BudgetDetailsHistoryVarianceCostBasedCell } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/history-section/cells/BudgetDetailsHistoryVarianceCostBasedCell";
import { getBudgetDetailsHistoryVarianceValueGetter } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/history-section/utils/helpers/valueGetters";
import { BudgetDetailsHistoryVariancePercentBasedCell } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/history-section/cells/BudgetDetailsHistoryVariancePercentBasedCell";

export const budgetDetailsHistoryTableColumnDefs: ColDef<ProcessedHistoryData>[] =
  [
    {
      headerName: "Date",
      field: "formatedDate",
      sort: "asc",
      comparator: budgetDetailsHistoryTableDateComparatorFn,
    },
    {
      field: "used",
      cellRenderer: BudgetDetailsHistoryUsedCell,
      comparator: budgetDetailsHistoryUsedComparator,
    },
    {
      field: "budget",
      cellRenderer: ({
        data,
      }: CustomCellRendererProps<ProcessedHistoryData>) => (
        <Typography variant="body2">{money(data?.budget)}</Typography>
      ),
    },
    {
      field: "budgetVarianceCostBased",
      headerName: "Budget Variance ($)",
      cellRenderer: BudgetDetailsHistoryVarianceCostBasedCell,
      valueGetter: getBudgetDetailsHistoryVarianceValueGetter(
        "budgetVarianceCostBased",
      ),
      comparator: getBudgetDetailsHistoryVarianceComparator(
        "budgetVarianceCostBased",
      ),
    },
    {
      field: "budgetVariancePercentage",
      headerName: "Budget Variance (%)",
      cellRenderer: BudgetDetailsHistoryVariancePercentBasedCell,
      valueGetter: getBudgetDetailsHistoryVarianceValueGetter(
        "budgetVariancePercentage",
      ),
      comparator: getBudgetDetailsHistoryVarianceComparator(
        "budgetVariancePercentage",
      ),
    },
  ];
